import AccountLinkForm from "../../components/IAM/AccountLinkForm";
import AccountLinkLock from "../../components/IAM/AccountLinkLock";
import AuthTemplate from "../templates/AuthTemplate";
import React from "react";
import { connect } from "react-redux";
import { isObject } from "@pheaa/channels-component-library";

const AccountLinkView = props => {

	let returnElem = <AccountLinkForm />;

	const { profileData } = props;

	if (isObject(profileData)) {
		const { registration = {} } = profileData;
		const { failedAttempts, nextAttemptAllowed } = registration;
		const now = new Date(new Date().toISOString()).getTime();
		const nextAllowed = new Date(nextAttemptAllowed).getTime();

		if (failedAttempts > 0 && nextAllowed > now) {
			returnElem = <AccountLinkLock nextAttemptAllowed={nextAttemptAllowed} />;
		}
	}

	return (
		<AuthTemplate>
			{returnElem}
		</AuthTemplate>
	);
};

const mapStateToProps = state => ({
	profileData: state.profile.data
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AccountLinkView);